import React from 'react'
import { useAuth } from './use-auth.js'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Link from '@material-ui/core/Link'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import packageJson from '../../package.json'
import useFormValidation from './useFormValidation'
import validateLogin from './validateLogin'
import { useHistory } from 'react-router-dom'
// const history = useHistory()
const INITIAL_STATE = {
  name: '',
  email: '',
  password: ''
}

function Copyright () {
  return (
    <Typography variant='body2' color='textSecondary' align='center'>
      {'Versioon: ' + packageJson.version}
    </Typography>
  )
}

const useStyles = makeStyles(theme => ({
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  error: {
    margin: theme.spacing(3, 0, 2),

    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    color: 'red',
    fontStyle: 'bold'
  }
}))
// < Route exact path = '/' >
//   { user?<Redirect to = '/mb' /> : <Login />}
//             </Route >
export default function LogIn (props) {
  const auth = useAuth()
  const classes = useStyles()
  const {
    handleSubmit,
    handleBlur,
    handleChange,
    values,
    errors,
    isSubmitting
  } = useFormValidation(INITIAL_STATE, validateLogin, authenticateUser)
  //const [login, setLogin] = React.useState(true)
  const loginError = null
  const history = useHistory()

  async function authenticateUser () {
    const { email, password } = values
    try {
      await auth.signin(email, password)
    } catch (err) {
      console.error('Audentimise viga', err)
      history.go(-1)
    } finally {
    }
  }
  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <Paper className={classes.paper} elevation={10}>
        <Typography variant='h5'>Logi sisse</Typography>
        <form onSubmit={handleSubmit} className={classes.form}>
          <TextField
            onChange={handleChange}
            value={values.email}
            name='email'
            variant='outlined'
            margin='normal'
            required
            fullWidth
            id='email'
            label='Email Aadress'
            autoComplete='username'
          />
          {errors.email && (
            <p className={classes.error}>{'Vale meili aadress'}</p>
          )}
          <TextField
            onChange={handleChange}
            value={values.password}
            name='password'
            variant='outlined'
            margin='normal'
            required
            fullWidth
            label='Password'
            type='password'
            id='password'
            autoComplete='current-password'
          />
          {errors.password && (
            <p className={classes.error}>{'Parool puudub'}</p>
          )}
          {loginError && <p className={classes.error}>{loginError}</p>}
          <Button
            type='submit'
            disabled={isSubmitting}
            fullWidth
            variant='contained'
            color='primary'
            className={classes.submit}
            style={{ background: isSubmitting ? 'grey' : 'blue' }}
          >
            Logi sisse
          </Button>

          <Grid container>
            <Grid item xs>
              <Link href='/#/signup' variant='body2'>
                {'Kas pole veel registreeritud? Registreeri'}
              </Link>
            </Grid>
          </Grid>
        </form>

        <Box mt={4}>
          <Copyright />
        </Box>
      </Paper>
    </Container>
  )
}
